import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class DeviceTypesService {

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}/devices/types`).then((data) => {
        resolve({ deviceTypes: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default DeviceTypesService;
